import React from 'react';
import PropTypes from 'prop-types';
import DateUtils from '../../../utils/DateUtils';
import config from '../../../config';
import moment from 'moment';
import NumberUtils from '../../../utils/NumberUtils';
class ActiveStandingOrderSingleFields extends React.Component {
  componentWillMount() {
    let futureDate = DateUtils.getMomentFromDateString(
      this.props.activeData.when
    );
    futureDate = moment(futureDate).format(config.dateFormatTimeline);
    this.state = {
      futureDate,
    };
  }
  componentDidMount() {}
  componentWillUnmount() {}
  render() {
    const formData = `${this.props.activeData.fromAccountName}-${this.props.activeData.fromAccountNumber}`;
    return (
      <dl className="c-definitions">
        <dt className="c-definitions__key">From</dt>
        <dd className="c-definitions__value">{formData}</dd>
        <dt className="c-definitions__key">To</dt>
        <dd className="c-definitions__value">
          {this.props.activeData.toAccountName}
        </dd>
        <dt className="c-definitions__key">Their sort code</dt>
        <dd className="c-definitions__value">
          {NumberUtils.formatSortCode(this.props.activeData.sortCode)}
        </dd>
        <dt className="c-definitions__key">Their account number</dt>
        <dd className="c-definitions__value">
          {this.props.activeData.accountNumber}
        </dd>
        <dt className="c-definitions__key">Reference</dt>
        <dd className="c-definitions__value">
          {this.props.activeData.reference}
        </dd>
        <dt className="c-definitions__key">Type</dt>
        <dd className="c-definitions__value">{this.props.activeData.type}</dd>
        <dt className="c-definitions__key">Amount</dt>
        <dd className="c-definitions__value">
          <strong>
            &pound;
            {NumberUtils.decimalFormat(this.props.activeData.amount, 3, false)}
          </strong>
        </dd>
        <dt className="c-definitions__key">When</dt>
        <dd className="c-definitions__value">{this.state.futureDate}</dd>
      </dl>
    );
  }
}
ActiveStandingOrderSingleFields.propTypes = {
  activeData: PropTypes.object,
};
export default ActiveStandingOrderSingleFields;
